export const name = "Acto Loan";
export const address = "Building No.: 163-S, Basement, Model Town, Hisar, Haryana - 125001";
export const phone = "+91-9138635416"
export const email= "support@actoloan.com"

